import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { IService } from '../store/schedule';
import { ScheduleApi } from '../api/schedule';
import { LoadingStatus } from '../store/types';

const useScheduleServices = (studyRoom: string, date: string) => {
  const history = useHistory();

  const [services, setServices] = useState<IService[]>([]);
  const [loading, setLoading] = useState<LoadingStatus>(LoadingStatus.NEVER);

  useEffect(() => {
    if (studyRoom && date) {
      (async () => {
        try {
          setLoading(LoadingStatus.LOADING);
          setServices(await ScheduleApi.getServices(studyRoom, date));
          setLoading(LoadingStatus.SUCCESS);
        } catch (e: any) {
          setLoading(LoadingStatus.ERROR);
        }
      })();
    }
  }, [studyRoom, date, history]);

  return {
    services,
    loading,
  };
};

export default useScheduleServices;
